import React from "react";
import { useNavigate } from "react-router-dom";

function AddButton() {
  const navigate = useNavigate();
  return (
    <button
      id="openModalBtn"
      onClick={() => navigate("/dashboard/adddiscussion")}
      className="flex items-center bg-gradient-to-r from-violet-300 to-indigo-300  border border-fuchsia-00 hover:border-violet-100 text-white font-semibold py-2 px-4 rounded-md transition-colors duration-300"
    >
      <svg
        className="w-4 h-4 mr-2 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
        ></path>
      </svg>
      <p className="text-white">New Question</p>
    </button>
  );
}

export default AddButton;
